// FEAT-025 — user 객체 정규화 헬퍼.
// 백엔드 응답 user 객체에 dealerType 필드가 없을 수 있는 legacy 경우를
// 'internal' 로 default 보정한다. 다운스트림(getLicenseRole, AuthRoute, 메뉴 등)
// 가 일관된 값을 받도록 single point of normalization.
//
// 적용 지점:
//   - AuthAction Login 응답 (`localStorage.user`, Redux `AuthReducer.user`)
//   - AuthAction UpdateUserFav / UpdateUserAdminFilters 응답
//   - (필요 시) 사용자 정보 갱신 응답
//
// dealerType 정규화 규칙:
//   - 'external' (대소문자 무시) → ExternalDealer 로 보존, 정규화된 lowercase 'external'
//   - 그 외(undefined / null / '' / 'internal' / 잘못된 값) → 'internal' 보정
//
// PR #185 R1 FYI 반영 — defense-in-depth: 백엔드 응답이 'EXTERNAL' / 'External' /
// '  external  ' 등 case/whitespace variant 를 보낼 경우에도 ExternalDealer 권한이
// 누락되어 InternalDealer 로 fall-open 되지 않도록 trim + lowercase 비교 후 정규 lowercase
// 값으로 저장. RBAC 권한 결정의 fail-closed 지향.
//
// licenseHelper.getLicenseRole 이 이미 strict 'external' 만 인정하므로, 본 단계에서
// 정규 'external' lowercase 로 박아두면 다운스트림 비교가 안전하게 동작.
export const normalizeUserDealerType = (user) => {
    if (!user || typeof user !== 'object') return user;
    const raw = typeof user.dealerType === 'string' ? user.dealerType.trim().toLowerCase() : '';
    if (raw === 'external') {
        // 이미 정규 lowercase 'external' 이면 참조 보존 (불필요한 spread 회피)
        if (user.dealerType === 'external') return user;
        return { ...user, dealerType: 'external' };
    }
    return { ...user, dealerType: 'internal' };
};
